var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJordan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.875C24.8366 32.875 32 25.7116 32 16.875C32 8.03844 24.8366 0.875 16 0.875C7.16344 0.875 0 8.03844 0 16.875C0 25.7116 7.16344 32.875 16 32.875Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 11.3098H31.0045C28.7438 5.217 22.8791 0.875 15.9997 0.875C11.5813 0.875 7.58177 2.66619 4.68652 5.56181L9.73884 11.3098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73884 22.4402H31.0045C28.7438 28.533 22.8791 32.875 15.9997 32.875C11.5813 32.875 7.58177 31.0838 4.68652 28.1882L9.73884 22.4402Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68677 5.56081C-1.56161 11.8092 -1.56161 21.9399 4.68677 28.1883C7.26883 25.6063 9.75214 23.1229 16.0005 16.8746L4.68677 5.56081Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.34991 13.3971L7.22798 15.2333L9.21104 14.775L8.32291 16.6063L9.9176 17.8709L7.93216 18.3183L7.93766 20.3536L6.34991 19.0803L4.7621 20.3536L4.76766 18.3183L2.78223 17.8709L4.37685 16.6063L3.48885 14.775L5.47179 15.2333L6.34991 13.3971Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJordan);
export default __webpack_public_path__ + "static/media/jordan.06b51532.svg";
export { ForwardRef as ReactComponent };